import React, { memo } from "react";

const PlusIcon = memo(({ className = "" }) => {
  return (
    <svg
      className={`vh-card__plus-svg ${className}`.trim()}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M20 28V12M12 20H28"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
});

export default PlusIcon;
